import { ReactNode } from 'react';
import { cx } from '../../../payease.utils';
import './field.scss';

interface IFieldProps {
  label: ReactNode;
  htmlFor?: string;
  labelSize?: 'sm' | 'md';
  children: ReactNode;
}

export const Field = ({ label, htmlFor, labelSize = 'md', children }: IFieldProps) => (
  <div className="pe-field">
    <label className={cx('pe-field__label', labelSize === 'sm' && 'pe-field__label--sm')} htmlFor={htmlFor}>
      {label}
    </label>
    {children}
  </div>
);
